import React from 'react';
import { makeStyles, Theme, createStyles, Paper, AppBar, Tabs, Tab, Grid, ButtonBase, Button } from '@material-ui/core';
import Character from '../../Character/Character'
import SpriteManager, { SpriteDefine } from '../../Character/SpriteManager'
import ColorPicker from './ColorPicker'
import { useTranslation } from "react-i18next"

import * as Lambda from '../../../Lambda';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
    paper: {
      maxWidth: 768,
      height: "90vh",
      display: "flex",
      flexDirection: "column",
    },
    select: {
      height: 0,
      flexGrow: 1,
      overflowY: "scroll",
      overflowX: "hidden",
    },
    mediaBoxIn: {
      display: "inline-block",
    },
    media: {
      height: 216,
      width: 384,
    },
    itemContainer: {
      width: "25%"
    },
    item: {
      margin: theme.spacing(1),
      boxShadow: "0 0 10px #555",
    },
    itemCurrent: {
      margin: theme.spacing(1),
      boxShadow: "0 0 10px #ffa500",
    },
    image: {
      width: "100%",
    },
    hidden: {
      display: "none"
    },
    sideBar: {
      height: "100%",
      padding: theme.spacing(1),
    },
    picker: {
      margin: "2px",
      padding: theme.spacing(1),
      borderRadius: 1,
      height: "2rem",
      width: "2rem",
      boxShadow: theme.shadows[3]
    },
    pickerIn: {
      height: "100%",
      width: "100%",
    },
  }),
);

interface Props {
  avatar: Lambda.AvatarType
  onSuccess?: (input: Lambda.AvatarType)=>void | undefined
}

function CharacterCreate(props: Props) {

    const classes = useStyles()
    const [t] = useTranslation()

    const [tab, setTab] = React.useState(0);
    const [spriteManager, setSpriteManager] = React.useState<SpriteDefine | undefined>();
    const [character, setCharacter] = React.useState(props.avatar)
    const [suspend, setSuspend] = React.useState(false)
    const handleUpdate = (avatar: Lambda.AvatarType) => {
      setCharacter(avatar)
      console.log(suspend)
    }
    const handleSuccess = () => {
      props.onSuccess?.(character)
    }

    return (
        <div className={classes.root}>
          <SpriteManager ready={(sm)=>setSpriteManager(sm)} />
          <Paper className={classes.paper}>
            <Grid 
              container  
              direction="row"
              justify="center"
              alignItems="stretch">
              <Character 
                sprite={spriteManager}
                character={character}
                />
              <Grid item>
                <Grid container direction="column" className={classes.sideBar}>
                  <ColorPicker
                    type="Block"
                    color={character.backgroundColor}
                    colors={["#ffcccc", "#ffe6cc", "#ffffcc", "#e6ffcc", "#ccffcc", "#ccffe6", "#ccffff", "#cce6ff", "#ccccff", "#e6ccff", "#ffccff", "#ffcce6"]}
                    label={t("message.characterCreate.bgColor")}
                    onColorChange={(color)=>handleUpdate({...character, backgroundColor:color})}
                    onDialogOpen={(open)=>setSuspend(open)}
                  />
                  <ColorPicker
                    type="Block"
                    color={character.bodyColor}
                    colors={["#fef1dd", "#feeecd", "#c19b87"]}
                    label={t("message.characterCreate.bgColor")}
                    onColorChange={(color)=>handleUpdate({...character, bodyColor:color})}
                    onDialogOpen={(open)=>setSuspend(open)}
                  />
                  <ColorPicker
                    type="Sketch"
                    color={character.hairColor}
                    label={t("message.characterCreate.hairColor")}
                    onColorChange={(color)=>handleUpdate({...character, hairColor:color})}
                    onDialogOpen={(open)=>setSuspend(open)}
                  />
                  <ColorPicker
                    type="Sketch"
                    color={character.eyeColor}
                    label={t("message.characterCreate.eyeColor")}
                    onColorChange={(color)=>handleUpdate({...character, eyeColor:color})}
                    onDialogOpen={(open)=>setSuspend(open)}
                  />
                  <div style={{flexGrow:1}}></div>
                  <Button variant="contained" color="primary" onClick={handleSuccess}>{t("message.characterCreate.success")}</Button>
                </Grid>
              </Grid>
            </Grid>
            <AppBar position="static" color="default">
              <Tabs
                value={tab}
                onChange={(e,v)=>setTab(v)}
                variant="scrollable"
                scrollButtons="on"
                indicatorColor="primary"
                textColor="primary"
                aria-label="scrollable force tabs example"
                >
                <Tab label={t("message.characterCreate.shirt")} />
                <Tab label={t("message.characterCreate.jacket")} />
                <Tab label={t("message.characterCreate.eye")} />
                <Tab label={t("message.characterCreate.hair")} />
                <Tab label={t("message.characterCreate.mouth")} />
                <Tab label={t("message.characterCreate.accessory")} />
              </Tabs>
            </AppBar>
            <div className={classes.select}>
              { tab === 0 ? 
                <div>
                  <Grid
                    container
                    spacing={1}
                  >
                    { Object.entries(spriteManager?.shirt || {}).map(([k])=>(
                      <Grid item className={classes.itemContainer}>
                        <ButtonBase 
                          onClick={()=>handleUpdate({...character, shirt:k})}
                          className={character.shirt === k ? classes.itemCurrent : classes.item }
                        >              
                          <Character 
                            sprite={spriteManager}
                            suspended={suspend}
                            character={{...character,shirt: k}}
                            />
                        </ButtonBase>
                      </Grid>
                    )) }
                  </Grid>
                </div> 
                : null}
                { tab === 1 ? 
                  <div>
                    <Grid
                      container
                      spacing={1}
                    >
                      { Object.entries(spriteManager?.jacket || {}).map(([k])=>(
                        <Grid item className={classes.itemContainer}>
                          <ButtonBase 
                            onClick={()=>handleUpdate({...character, jacket:k})}
                            className={character.jacket === k ? classes.itemCurrent : classes.item }
                          >              
                            <Character 
                              sprite={spriteManager}
                              suspended={suspend}
                              character={{...character,jacket: k}}
                              />
                          </ButtonBase>
                        </Grid>
                      )) }
                    </Grid>
                  </div> 
                  : null}
              { tab === 2 ? 
                <div>
                  <Grid
                    container
                    spacing={1}
                  >
                    { Object.entries(spriteManager?.eye || {}).map(([k])=>(
                      <Grid item className={classes.itemContainer}>
                        <ButtonBase 
                          onClick={()=>handleUpdate({...character, eye:k})}
                          className={character.eye === k ? classes.itemCurrent : classes.item }
                        >              
                          <Character 
                            sprite={spriteManager}
                            suspended={suspend}
                            character={{...character, eye:k}}
                            />
                        </ButtonBase>
                      </Grid>
                    )) }
                  </Grid>
                </div> 
                : null}
              { tab === 3 ? 
                <div>
                  <Grid
                    container
                    spacing={1}
                  >
                    { Object.entries(spriteManager?.hair || {}).map(([k])=>(
                      <Grid item className={classes.itemContainer}>
                        <ButtonBase 
                          onClick={()=>handleUpdate({...character, hair:k})}
                          className={character.hair === k ? classes.itemCurrent : classes.item }
                        >              
                          <Character 
                            sprite={spriteManager}
                            suspended={suspend}
                            character={{...character, hair:k}}
                            />
                        </ButtonBase>
                      </Grid>
                    )) }
                  </Grid>
                </div> 
                : null}
              { tab === 4 ? 
                <div>
                  <Grid
                    container
                    spacing={1}
                  >
                    { Object.entries(spriteManager?.mouth || {}).map(([k])=>(
                      <Grid item className={classes.itemContainer}>
                        <ButtonBase 
                          onClick={()=>handleUpdate({...character, mouth:k})}
                          className={character.mouth === k ? classes.itemCurrent : classes.item }
                        >              
                          <Character 
                            sprite={spriteManager}
                            suspended={suspend}
                            character={{...character,mouth: k}}
                            />
                        </ButtonBase>
                      </Grid>
                    )) }
                  </Grid>
                </div> 
                : null}
              { tab === 5 ? 
                <div>
                <Grid
                  container
                  spacing={1}
                >
                  { Object.entries(spriteManager?.accessory || {}).map(([k])=>(
                    <Grid item className={classes.itemContainer}>
                      <ButtonBase 
                        onClick={()=>handleUpdate({...character, accessory:k})}
                        className={character.accessory === k ? classes.itemCurrent : classes.item }
                      >              
                        <Character 
                          sprite={spriteManager}
                          suspended={suspend}
                          character={{...character,accessory: k}}
                          />
                      </ButtonBase>
                    </Grid>
                  )) }
                </Grid>
                </div> 
                : null}
              </div>
          </Paper>
        </div>
    )
}

export default CharacterCreate;